<div class="page-wrapper page-container" [style.background-image]="backgroundImageUrl()">
      <div class="card">
        <div class="card-header">{{'SB_Expired_Password_Token' | translate}}</div>
        <div class="card-body">
          <p>
            {{'SB_The_token_you_are_attempting_to_use_has_now_expired' | translate}}
          </p>
          <div class="d-flex gap-2 mb-3 mt-3 align-items-center">
            <label for="email" class="text-nowrap mr-3">{{'SB_Email_Address' | translate}}</label>
            <input type="email" class="form-control" id="email" [(ngModel)]="email" readonly/>
          </div>
          <button class="btn btn-primary" (click)="requestNewToken()">{{'SB_Request_Reset_Token' | translate}}</button>
        </div>
  </div>

  <footer class="footer bg-dark text-light py-2 mt-auto">
    <p class="small text-center mb-1">
      <a class="link-light" href="http://www.schoolsbuddy.com" target="_blank">
        &copy; {{ currentYear }} - EveryBuddy Ltd
      </a>
    </p>
    <p class="small text-center mb-0">
      <a class="link-light" href="http://www.schoolsbuddy.com" target="_blank">
        {{'SB_About' | translate}}
      </a>
    </p>
  </footer>
</div>
